<template>
  <div v-if="selectedBot && selectedBot.packages">
    <template>
      <div>
        <v-layout wrap v-if="currentLang != 'la'">
          <v-flex sm6 xs12 lg3 class="px-2 text-xs-center">
            <div class="card-package z-border-red">
              <h4>3 {{ $t('months') }}</h4>
              <div class="hr" style="margin-bottom: 15px;"></div>
              <br />
              <p class="price">{{ $t('Price') }} 1,500 {{ $t('Baht') }}</p>
              <span class="discount" style="content: ' '"></span>
              <p>500 {{ $t('Baht per month') }}</p>

              <div class="hr"></div>
              <div ref="btn_3month_fb" id="btn_3month_fb" style="margin-top: 15px;"></div>
              <premium-form
                :params="'btn_3month_fb'"
                :type="'paypal'"
                :pack="'3 Months 1,500 Baht'"
              ></premium-form>
              <div class="caption" style="margin-top: .5em">{{ $t('or') }}</div>
              <premium-form
                :params="'8521'"
                :type="'transfer'"
                :pack="'3 Months 1,500 Baht'"
              ></premium-form>
            </div>
          </v-flex>
          <v-flex sm6 xs12 lg3 class="px-2 text-xs-center">
            <div class="card-package z-border-red">
              <div class="sale-tag shadow">{{ $t('Save Price') }} 7%</div>
              <h4>6 {{ $t('months') }}</h4>
              <div class="hr" style="margin-bottom: 15px;"></div>
              <br />
              <p class="price">{{ $t('Price') }} 2,799 {{ $t('Baht') }}</p>
              <span class="discount">{{ $t('from') }} 3,000 {{ $t('Baht') }}</span>
              <p>466.5 {{ $t('Baht per month') }}</p>
              <div class="hr"></div>
              <div ref="btn_6month_fb" id="btn_6month_fb" style="margin-top: 15px;"></div>
              <premium-form
                :params="'btn_6month_fb'"
                :type="'paypal'"
                :pack="'6 Months 2,799 Baht'"
              ></premium-form>
              <div class="caption" style="margin-top: .5em">{{ $t('or') }}</div>
              <premium-form
                :params="'8520'"
                :type="'transfer'"
                :pack="'6 Months 2,799 Baht'"
              ></premium-form>
            </div>
          </v-flex>
          <v-flex sm6 xs12 lg3 class="px-2 text-xs-center">
            <div class="card-package z-border-red">
              <div class="sale-tag shadow">{{ $t('Save Price') }} 17%</div>
              <h4>1 {{ $t('Year') }}</h4>
              <div class="hr" style="margin-bottom: 15px;"></div>
              <br />
              <p class="price">{{ $t('Price') }} 4,999 {{ $t('Baht') }}</p>
              <span class="discount">{{ $t('from') }} 6,000 {{ $t('Baht') }}</span>
              <p>416.58 {{ $t('Baht per month') }}</p>
              <div class="hr"></div>
              <!-- <p style="color:red">Save Price 1,000 baht</p> -->
              <div ref="btn_12month_fb" id="btn_12month_fb" style="margin-top: 15px;"></div>
              <premium-form
                :params="'btn_12month_fb'"
                :type="'paypal'"
                :pack="'1 Year 4,999 Baht'"
              ></premium-form>
              <div class="caption" style="margin-top: .5em">{{ $t('or') }}</div>
              <premium-form
                :params="'8519'"
                :type="'transfer'"
                :pack="'1 Year 4,999 Baht'"
              ></premium-form>
            </div>
          </v-flex>
          <v-flex sm6 xs12 lg3 class="px-2 text-xs-center">
            <div class="card-package z-border-red">
              <div class="sale-tag shadow">{{ $t('Save Price') }} 15%</div>
              <p class="title primary--text">1 {{ $t('Year') }}</p>
              <p class="title primary--text">{{ $t('Extra Service') }}</p>
              <div class="hr" style="margin-bottom: 15px;"></div>
              <div>{{ $t('Including set-up & personal training') }}</div>
              <p class="price">{{ $t('Price') }} 5,999 {{ $t('Baht') }}</p>
              <span class="discount">{{ $t('from') }} 7,000 {{ $t('Baht') }}</span>
              <p>500 {{ $t('Baht per month') }}</p>

              <div class="hr"></div>
              <div
                ref="btn_12month_extra_fb"
                id="btn_12month_extra_fb"
                style="margin-top: 15px;"
              ></div>
              <premium-form
                :params="'btn_12month_extra_fb'"
                :type="'paypal'"
                :pack="'1 Year Extra 5,999 Baht'"
              ></premium-form>
              <div class="caption" style="margin-top: .5em">{{ $t('or') }}</div>
              <premium-form
                :params="'12233'"
                :type="'transfer'"
                :pack="'1 Year Extra 5,999 Bahts'"
              ></premium-form>
            </div>
          </v-flex>
        </v-layout>
        <div v-else>
          <div class="card-package z-border-red text-xs-center">
            <h5 v-if="$store.getters.getPackage != 'premium'">ຖ້າຢາກໃຊ້ແພັກເກດລາວແຊັດບອ໋ດ</h5>
            <h5 v-else>ຖ້າທ່ານສົງໃສ ຫລືມີຄວາມຕ້ອງການອື່ນໆ</h5>
            <a href="https://www.facebook.com/coach4mkt/" target="_blank">
              <v-btn depressed color="primary">ຕິດຕໍ່ພວກເຮົາ</v-btn>
            </a>
          </div>
        </div>
      </div>

      <template v-if="false">
        <div>
          <div style="margin: 35px 0px;">
            <h3 class="text-xs-center title">Add-on Line Chatbot Package</h3>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-4 text-xs-center">
              <div class="card-package">
                <strong>Basic Package</strong>
                <hr />
                <h3 class="title">+1,498 Baht / Month</h3>

                <hr />
                <p>1 Basic Line@ Account</p>
                <hr />
                <p>1 Line Chatbot</p>
                <hr />

                <a :href="'mailto:' + $store.state.theme.email_contact" class="btn btn-select-plan"
                  >Contact Us</a
                >
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 text-xs-center">
              <div class="card-package">
                <strong>Pro Package</strong>
                <hr />
                <h3 class="title">+2,498 Baht / Month</h3>

                <hr />
                <p>1 Pro Line@ Account</p>
                <hr />
                <p>1 Line Chatbot</p>
                <hr />

                <!-- <p style="color:red">Save Price 1,000 baht</p> -->
                <a :href="'mailto:' + $store.state.theme.email_contact" class="btn btn-select-plan"
                  >Contact Us</a
                >
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 text-xs-center">
              <div class="card-package">
                <strong>Pro+ Package</strong>
                <hr />
                <h3 class="title">+7,388 Baht / Month</h3>

                <hr />
                <p>1 Pro+ Line@ Account</p>
                <hr />
                <p>1 Line Chatbot</p>
                <hr />

                <!-- <p style="color:red">Save Price 1,000 baht</p> -->
                <a :href="'mailto:' + $store.state.theme.email_contact" class="btn btn-select-plan"
                  >Contact Us</a
                >
              </div>
            </div>
          </div>
        </div>
      </template>

      <modal-dialog @close="showSuccess = false" v-if="showSuccess">
        <div slot="body" class="text-xs-center" style="margin-top: 45px;">
          <img src="/static/img/assets/shop/success_mark.png" alt style="width: 150px;" />
          <h5>Payment Successful</h5>
        </div>

        <div slot="footer" class="text-xs-center" style="padding: 10px">
          <a href="javascript:void(0)" class="btn btn-primary" @click="showSuccess = false"
            >Close</a
          >
        </div>
      </modal-dialog>

      <modal-dialog @close="showFail = false" v-if="showFail">
        <div slot="body" class="text-xs-center" style="margin-top: 45px;">
          <img src="/static/img/assets/shop/fail_mark.png" alt style="width: 150px;" />
          <h5>Payment Unsuccessful</h5>
          <p class="small">{{ errorMessage }}</p>
        </div>

        <div slot="footer" class="text-xs-center" style="padding: 10px">
          <a href="javascript:void(0)" class="btn btn-primary" @click="showFail = false">Close</a>
        </div>
      </modal-dialog>
    </template>
    <template v-if="false">
      <div v-if="!selectedBot.packages.includes('line')"></div>
      <div v-else>
        <div class="text-xs-center" style="margin-top: 35px;">
          <div>
            <img
              src="/static/img/assets/setting/expired_alert@2x.png"
              alt
              style="max-width: 230px; width: 100% "
            />
          </div>
          <br />
          <p>
            Please contact email
            <a :href="'mailto:' + $store.state.theme.email_contact">{{
              $store.state.theme.email_contact
            }}</a>
            for more information.
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ModalDialog from '@/components/elements/ModalDialog'
import { setInterval, clearInterval } from 'timers'
import premiumForm from '@/components/elements/premiumForm.vue'
import api from '@/api'

export default {
  data: function() {
    return {
      environment: 'production',
      showSuccess: false,
      showFail: false,
      errorMessage: '',
      paypal_actions: undefined,
      dialog: false,
      lineid: ''
    }
  },
  components: {
    ModalDialog,
    premiumForm
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      currentLang: 'currentLang'
    })
  },
  mounted: function() {
    var vm = this
  },
  methods: {
    confirm() {
      let vm = this
      vm.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        let data = { pageid: vm.selectedBot.pageid, lineid: vm.lineid }
        api.collectlineidpremiumextra(data, (error, response) => {
          if (error) console.error(error)
          alert('success')
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/setting/ViewPackage.vue